import { reloadWithCalculationFlash } from "../reload_with_flash";

const LOADER = ".generic-loader";

const isScoresPage = () =>
  window.location.href.includes(`/leagues/${gon.league_id}/scores`);

export default class PositionRoundHandler {
  constructor() {
    this.shown = false;
  }

  reset() {
    this.shown = false;
    window.stopCalculationAutoReload = false;
  }

  syncFromWindow() {
    this.shown = Boolean(window.stopCalculationAutoReload);
  }

  handle(status) {
    if (status.processType !== "calculate") return;
    if (!status.hasNextRoundAsPosition || this.shown) return;
    if (status.hasPendingRounds) return;

    this.shown = true;
    window.stopCalculationAutoReload = true;
    this.confirmNextPositionRound(status.nextRound);
  }

  confirmNextPositionRound(round) {
    const text =
      "Your next round is a position round would you like to create the pairings now?";

    window.swalConfirm
      .fire({
        title: "Notice",
        text,
        confirmButtonText: `Yes, Create the pairings for ${round.formatted_date}`,
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) return this.generateNextPositionRound(round);
        if (!isScoresPage()) return;

        reloadWithCalculationFlash();
      });
  }

  generateNextPositionRound(round) {
    const url = `/leagues/${gon.league_id}/matches/round_robins/${round.id}?regenerate_type=position-round`;
    $(LOADER).removeClass("d-none");

    $.ajax({
      method: "PUT",
      url,
    });
  }
}
